import { Bed, Bath, Tv, Wifi, Car } from "lucide-react";
import RoomDetail from "./RoomDetail";
import economyRoom1 from "@/assets/economy-room-1.jpeg";
import economyRoom2 from "@/assets/economy-room-2.jpeg";
import economyRoom3 from "@/assets/economy-room-3.jpeg";
import economyRoom4 from "@/assets/economy-room-4.jpeg";
import economyRoom5 from "@/assets/economy-room-5.jpeg";
import economyRoom6 from "@/assets/economy-room-6.jpeg";
import economyRoom7 from "@/assets/economy-room-7.jpeg";
import economyRoom8 from "@/assets/economy-room-8.jpeg";
import economyRoom9 from "@/assets/economy-room-9.jpeg";
import economyRoom10 from "@/assets/economy-room-10.jpeg";
import economyRoom11 from "@/assets/economy-room-11.jpeg";
import economyRoom12 from "@/assets/economy-room-12.jpeg";
import economyRoom13 from "@/assets/economy-room-13.jpeg";
import economyRoom14 from "@/assets/economy-room-14.jpeg";
import { useLanguage } from "@/i18n/LanguageContext";
import { useRoomContent } from "@/hooks/useRoomContent";

const TwinRoom = () => {
  const { t } = useLanguage();
  const { current } = useRoomContent("twin");
  const rd = t.roomData;
  const images = [
    { src: economyRoom1, alt: current?.title || t.subpageHeroes.twinRoom.title },
    { src: economyRoom4, alt: "Bett & Waschbecken" },
    { src: economyRoom9, alt: "Einzelbett & Sofabett" },
    { src: economyRoom10, alt: "Schreibtisch & TV" },
    { src: economyRoom11, alt: "Doppelbett klassisch" },
    { src: economyRoom12, alt: "Einzelbett & Sofabett" },
    { src: economyRoom13, alt: "Schreibtisch & Smart TV" },
    { src: economyRoom14, alt: "Doppelbett weiss" },
    { src: economyRoom7, alt: "Esstisch" },
    { src: economyRoom8, alt: "TV & Schrank" },
    { src: economyRoom2, alt: "TV & Garderobe" },
    { src: economyRoom3, alt: "Waschbecken" },
    { src: economyRoom5, alt: "Gemeinschafts-WC" },
    { src: economyRoom6, alt: "Gemeinschafts-Dusche" },
  ];
  const amenityLabels = current?.amenities?.length ? current.amenities : rd.twin.amenities;
  const amenities = amenityLabels.map((label, i) => ({
    icon: [Bed, Bath, Tv, Wifi, Car][i],
    label,
  }));
  return (
    <RoomDetail
      title={current?.title || t.subpageHeroes.twinRoom.title}
      subtitle={current?.description || t.subpageHeroes.twinRoom.subtitle}
      images={images}
      amenities={amenities}
      features={rd.features}
      highlight={{ image: economyRoom14, title: current?.highlight || rd.twin.highlight, subtitle: current?.highlightSub || rd.twin.highlightSub }}
    />
  );
};

export default TwinRoom;
